var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wework-steps-head"},[(_vm.title)?_c('div',{staticClass:"wework-steps-head-tit"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('p',{staticClass:"wework-steps-head-desc"},[_vm._t("desc")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }